import { useEffect, useState } from "react"
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { ToastContainer, toast } from "react-toastify"


import styles from './styles.module.css'
import { authApi } from "../../services/api/api"
import useAuth from "../../hooks/useAuth"

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Comment from "../comment"
import TextEditor from "../textEditor";
import { ChatBubbleOutline, Favorite, FavoriteBorder } from "@mui/icons-material";
import { FastAverageColor } from "fast-average-color";
import { Edit, LogOutIcon, Pen, Trash, Trash2 } from "lucide-react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
export default function Indications({ item, handleComment, atualizar, setAtualizar }: any) {

    const api = authApi()

    const { user, theme } = useAuth()

    const [likes, setLikes] = useState(item.likes)

    const [liked, setLiked] = useState(item.like ? true : false)

    const [text, setText] = useState(item.description ?? '')

    const [textComment, setTextComment] = useState('')

    const [open, setOpen] = useState(false);

    const themeMui = useTheme();

    const isMobile = useMediaQuery(themeMui.breakpoints.down('sm'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    async function setComment() {
        toast.loading('Carregando...', { theme: 'dark', toastId: 'load_comment' })
        if (user) {
            const data = {
                'user': user.id,
                'indication': item.id,
                'text': textComment
            }

            await handleComment(data)
        }
        handleClose()
        toast.dismiss('load_comment')
    }

    async function handleLikeIndication() {


        if (user) {
            const response = await api.likeIndication(item.id, user.id)

            if (response === 200) {
                setLiked(true)
                setLikes(likes + 1)
            } else {
                setLiked(false)
                setLikes(likes - 1)
            }
        }
    }

    async function handleDelete() {

        const response = await api.destroyIndication(item.id)


        if (response == 200) {
            toast.success('Publicação excluida com sucesso.', { theme: 'dark', toastId: 'deleteSuccsess' })
            setAtualizar(!atualizar)
            handleClose1()
            return
        }
        handleClose1()
        toast.info('Não foi possível excluir a publicação.', { theme: 'dark', toastId: 'errorDelete' })

    }

    async function handleUpdate() {

        const data = {
            id: item.id,
            text: text
        }

        toast.loading('Carregando.', { theme: 'dark', toastId: 'loadUpdate' })

        const response = await api.updateIndication(data)

        if (response == 200) {
            toast.dismiss('loadUpdate')
            setAtualizar(!atualizar)
            handleClose2()
        } else {
            toast.dismiss('loadUpdate')
            toast.error('Não foi possivel atualizar a indicação.', { theme: 'dark', toastId: 'erroUpdate' })
        }

    }
 

    return (
        <div className="w-full max-w-4xl mx-auto mb-6 transition-all duration-300 mt-4">
            <div className="bg-white dark:bg-[#0d2d5f]/30 rounded-3xl shadow-sm border border-gray-100 dark:border-white/5 overflow-hidden">

                {/* Topo: Informações do Usuário */}
                <div className="px-6 py-4 flex items-center bg-gray-50/50 justify-between dark:bg-[#2d3d5780] border-b border-gray-50 dark:border-white/5">
                    <div className="flex items-center gap-3">
                        <img
                            src={item?.user.img ?? ""}
                            alt="foto do usuario"
                            className="w-10 h-10 rounded-full object-cover border-2 border-blue3 shadow-sm"
                        />
                        <div>
                            <h3 className="text-sm font-bold text-gray-900 dark:text-white leading-none">
                                {item?.user.name ?? ""}
                            </h3>
                            <span className="text-[11px] text-gray-400 font-medium uppercase tracking-wider">
                                Recomendou uma obra
                            </span>
                        </div>
                    </div>

                    {/* Ações de Dono da Indicação */}
                    {item.user_id == user.id && (
                        <div className="flex gap-1">
                            <button onClick={handleClickOpen2} className="p-2 text-gray-400 hover:text-blue3 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-full transition-colors">
                                <Pen size={17} />
                            </button>
                            <button onClick={handleClickOpen1} className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-full transition-colors">
                                <Trash2 size={17} />
                            </button>
                        </div>
                    )}
                </div>

                {/* Corpo: O Livro e a Descrição */}
                <div className="p-6">
                    <div className="flex flex-col md:flex-row gap-6" >

                        {/* Visual do Livro Mini */}
                        <div className="flex flex-col items-center gap-3 shrink-0" >
                            <div className="p-2.5 rounded-lg">

                                <div className="relative group" >
                                    <img
                                        src={item.book.img}
                                        alt="capa do livro"
                                        className="w-24 h-36 object-cover rounded-lg shadow-md transition-transform group-hover:scale-105"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Texto da Indicação */}
                        <div className="flex-1">
                            <div className="mb-4">
                                <h4 className="text-lg font-black text-gray-900 dark:text-white leading-tight capitalize">
                                    {item.book.title}
                                </h4>
                                <p className="text-xs text-blue4 dark:text-blue-400 font-semibold italic">
                                    {item.book.autor}
                                </p>
                            </div>

                            <div className="relative">
                                <div
                                    className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed max-h-48 overflow-y-auto custom-scrollbar pr-2"
                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Base: Ações Sociais */}
                <div className="px-6 py-3 bg-gray-50/50 dark:bg-[#2d3d5780] flex items-center gap-6 border-t border-gray-50 dark:border-white/5">
                    <button
                        onClick={handleLikeIndication}
                        className={`flex items-center gap-2 text-sm font-bold transition-colors ${liked ? 'text-red-600' : 'text-gray-400 hover:text-red-500'}`}
                    >
                        {liked ? <Favorite fontSize="small" /> : <FavoriteBorder fontSize="small" />}
                        <span>{likes} curtidas</span>
                    </button>

                    <button
                        onClick={handleClickOpen}
                        className="flex items-center gap-2 text-sm font-bold text-gray-400 hover:text-blue3 transition-colors"
                    >
                        <ChatBubbleOutline fontSize="small" />
                        <span>{item?.comment?.length ?? 0} Comentários</span>
                    </button>
                </div>

                {/* Seção de Comentários (Sanfona ou Lista) */}
                {item?.comment?.length > 0 && (
                    <div className="bg-gray-50/30 dark:bg-black/5 p-6 space-y-4">
                        {item.comment.map((comment: any) => (
                            <Comment
                                atualizar={atualizar}
                                setAtualizar={setAtualizar}
                                key={comment.id}
                                item={comment}
                            />
                        ))}
                    </div>
                )}
            </div>

            {/* Diálogos seguindo o mesmo padrão arredondado */}
            {/* ... Seus Dialogs aqui ... */}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen={isMobile}

                PaperProps={{
                    style: {
                        borderRadius: isMobile ? '0px' : '24px',
                        backgroundImage: 'none',
                        maxWidth: '550px',
                        width: '100%',
                        overflow: 'hidden' // Garante que o header azul respeite o arredondamento
                    },
                }}
            >
                {/* Header do Modal com a Paleta Azul */}
                <div className="bg-gradient-to-r from-blue1 to-blue3 px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-3">
                        <div className="bg-white/20 p-2 rounded-lg backdrop-blur-md">
                            <ChatBubbleOutline className="text-white" style={{ fontSize: 20 }} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-blue-200/80 block leading-none mb-1">
                                Nova Interação
                            </span>
                            <h3 className="text-lg font-bold text-white leading-none">
                                Escreva seu comentário
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8">
                    <DialogContentText id="alert-dialog-description">
                        <div className="flex flex-col gap-2">
                            <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                Sua mensagem
                            </label>
                            <div className="rounded-2xl border-2 border-gray-100 dark:border-white/5 overflow-hidden bg-white shadow-inner focus-within:border-blue-500/50 transition-all">
                                <TextEditor setText={setTextComment} className="p-2" />
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex gap-3 border-t  border-gray-100 ">
                    <div className="my-2 w-full flex">
                        <button
                            onClick={handleClose}
                            className="flex-1 h-11 text-sm font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors"
                        >
                            CANCELAR
                        </button>
                        <button
                            onClick={setComment}
                            className="flex-[2] h-11 bg-blue3 hover:bg-blue4 text-white text-xs font-bold rounded-xl shadow-lg shadow-blue-500/30 transition-all active:scale-95 uppercase tracking-widest"
                        >
                            Publicar Comentário
                        </button>
                    </div>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '24px',
                        backgroundImage: 'none',
                        maxWidth: '450px', // Um pouco mais estreito por ser apenas um aviso
                        width: '100%',
                        overflow: 'hidden'
                    },
                }}
            >
                {/* Header do Modal - Gradiente de Alerta (Vermelho/Laranja) */}
                <div className="bg-gradient-to-r from-[#800000] to-[#e63946] px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-3">
                        <div className="bg-white/20 p-2 rounded-lg backdrop-blur-md text-white">
                            <Trash2 size={17} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-red-100/80 block leading-none mb-1">
                                Ação Irreversível
                            </span>
                            <h3 className="text-lg font-bold text-white leading-none">
                                Excluir Indicação
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8 pb-4">
                    <div className="flex flex-col items-center text-center gap-3">
                        <div className="w-16 h-16 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center mb-2">
                            <LogOutIcon className="text-red-600 rotate-180" style={{ fontSize: 30 }} />
                        </div>
                        <h1 className="text-xl font-bold text-gray-800 dark:text-white">
                            Você tem certeza?
                        </h1>
                        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed px-4">
                            Ao confirmar, sua indicação e todos os comentários vinculados serão removidos permanentemente da <strong>Biblioteca Acreditar</strong>.
                        </p>
                    </div>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex flex-col sm:flex-row gap-3 border-t border-gray-100">
                    <div className="flex w-full my-2">
                        <button
                            onClick={handleClose1}
                            className="flex-1 h-11 text-xs font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors tracking-widest order-2 sm:order-1"
                        >
                            MANTER INDICAÇÃO
                        </button>
                        <button
                            onClick={handleDelete}
                            className="flex-1 h-11 bg-red-600 hover:bg-red-700 text-white text-xs font-bold rounded-xl shadow-lg shadow-red-500/30 transition-all active:scale-95 uppercase tracking-widest order-1 sm:order-2"
                        >
                            SIM, DELETAR
                        </button>
                    </div>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen={isMobile}

                PaperProps={{
                    style: {
                        borderRadius: isMobile ? '0px' : '24px',
                        backgroundImage: 'none',
                        maxWidth: '600px',
                        width: '100%',
                        overflow: 'hidden'
                    },
                }}
            >
                {/* Header do Modal - Padronizado com Gradiente Azul */}
                <div className="bg-gradient-to-r from-[#000040] to-[#103E89] px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-3">
                        <div className="bg-white/20 p-2 rounded-lg backdrop-blur-md text-white">
                            <Pen size={17} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-blue-200/80 block leading-none mb-1">
                                Edição
                            </span>
                            <h3 className="text-lg font-bold text-white leading-none">
                                Atualizar Indicação
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8">
                    <DialogContentText id="alert-dialog-description">
                        <div className="flex flex-col gap-2">
                            <label className="text-[10px] uppercase font-bold tracking-widest text-gray-400 ml-1">
                                Modificar seu texto
                            </label>
                            <div className="rounded-2xl border-2 border-gray-100 dark:border-white/5 overflow-hidden bg-white shadow-inner focus-within:border-blue-500/50 transition-all">
                                {/* Passando o texto atual e a função de set */}
                                <TextEditor text={text} setText={setText} />
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex gap-3 border-t border-gray-100">
                    <div className="flex w-full my-2">
                        <button
                            onClick={handleClose2}
                            className="flex-1 h-11 text-xs font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors tracking-widest"
                        >
                            DESCARTAR
                        </button>
                        <button
                            onClick={handleUpdate}
                            className="flex-[2] h-11 bg-blue3 hover:bg-blue4 text-white text-xs font-bold rounded-xl shadow-lg shadow-blue-500/30 transition-all active:scale-95 uppercase tracking-widest"
                        >
                            Salvar Alterações
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>



    )
}